import { api } from './client.js';

/**
 * Global federated search. Returns the categorized result groups:
 *   { query, groups: [{ type, label, total, items: [{ id, title, subtitle, entity }] }] }
 */
export const searchApi = {
  global: (params) => api.get('/search', { query: params })
};
